import { baseApi } from "@/config/http-common";
import { AxiosPromise } from "axios";
import {
  DocumentBatch,
  DocumentBatchItem,
  DocumentBatchItemRequest,
  DocumentBatchUserProfile,
} from "@/types/documents/documentBatch/DocumentBatch";

interface ApiResponse<T> {
  status: boolean;
  message: string;
  type: string;
  data: T;
}

class DocumentBatchDataService {
  start(data: {
    name: string;
    idempotencyKey: string;
    expectedItems: number;
  }): AxiosPromise<ApiResponse<DocumentBatch>> {
    return baseApi.post("/documents/document-batch", data);
  }

  createItem(
    batchId: string,
    data: DocumentBatchItemRequest
  ): AxiosPromise<ApiResponse<DocumentBatchItem>> {
    return baseApi.post(`/documents/document-batch/${batchId}/items`, data);
  }

  recordPreparationFailure(
    batchId: string,
    data: {
      itemKey: string;
      recipientUserId: string;
      templateId: string;
      sendForExecution: boolean;
    }
  ): AxiosPromise<ApiResponse<DocumentBatchItem>> {
    return baseApi.post(
      `/documents/document-batch/${batchId}/items/failure`,
      data
    );
  }

  get(batchId: string): AxiosPromise<ApiResponse<DocumentBatch>> {
    return baseApi.get(`/documents/document-batch/${batchId}`);
  }

  getProfiles(data: {
    constructorId: string;
    processGuids: string[];
    userIds: string[];
  }): AxiosPromise<ApiResponse<DocumentBatchUserProfile[]>> {
    return baseApi.post("/documents/document-batch/profiles", data);
  }
}

export default new DocumentBatchDataService();
